/**
 * @generated SignedSource<<514952e999a3b650e150e1954895e67f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductTaskResultStatus = "ERROR" | "PARTIAL" | "PENDING" | "SKIPPED" | "SUCCESS";
export type ProductTaskState = "CANCELLED" | "COMPLETED" | "ERROR" | "PARTIAL_SUCCESS" | "PROCESSING" | "WAITING";
export type productDuplicationTaskQueriesTaskQuery$variables = {
  taskId: number;
};
export type productDuplicationTaskQueriesTaskQuery$data = {
  readonly productTask: {
    readonly createdOn: string;
    readonly id: string;
    readonly isLocked: boolean;
    readonly modifiedOn: string;
    readonly progress: {
      readonly completedOperations: number;
      readonly currentProductId: string | null;
      readonly lastUpdatedAt: string | null;
      readonly overallProgress: number;
      readonly productProgress: ReadonlyArray<{
        readonly key: number;
        readonly value: {
          readonly productId: number;
          readonly productName: string;
          readonly status: ProductTaskResultStatus;
        };
      }> | null;
      readonly startedAt: string | null;
      readonly totalOperations: number;
    } | null;
    readonly result: {
      readonly completedAt: string | null;
      readonly failedProducts: number;
      readonly overallErrorMessage: string | null;
      readonly overallErrorType: string | null;
      readonly overallStatus: ProductTaskResultStatus;
      readonly productResults: ReadonlyArray<{
        readonly key: number;
        readonly value: {
          readonly errorMessage: string | null;
          readonly errorType: string | null;
          readonly newProductId: number | null;
          readonly productId: number;
          readonly productName: string | null;
          readonly productSKU: string | null;
          readonly status: ProductTaskResultStatus;
        };
      }> | null;
      readonly successfulProducts: number;
      readonly totalProducts: number;
    } | null;
    readonly settings: {
      readonly assignPricingRules: boolean;
      readonly cloneTemplates: boolean | null;
      readonly destinationProductIds: ReadonlyArray<string>;
      readonly destinationProducts: ReadonlyArray<{
        readonly id: string;
        readonly imageUrl: string | null;
        readonly name: string | null;
        readonly sku: string | null;
        readonly statusId: number | null;
      }>;
      readonly salesChannelId: number | null;
      readonly sellerID: number;
      readonly sourceProductId: string;
      readonly userID: number | null;
    } | null;
    readonly status: number;
    readonly taskID: number;
    readonly taskState: ProductTaskState;
    readonly type: string;
  } | null;
};
export type productDuplicationTaskQueriesTaskQuery = {
  response: productDuplicationTaskQueriesTaskQuery$data;
  variables: productDuplicationTaskQueriesTaskQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productName",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "taskId",
        "variableName": "taskId"
      }
    ],
    "concreteType": "ProductTaskDto",
    "kind": "LinkedField",
    "name": "productTask",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      (v2/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskState",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isLocked",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modifiedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductTaskSettingsDto",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceProductId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "destinationProductIds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductTaskDestinationProduct",
            "kind": "LinkedField",
            "name": "destinationProducts",
            "plural": true,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sku",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cloneTemplates",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignPricingRules",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "salesChannelId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sellerID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userID",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductTaskProgressDto",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentProductId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalOperations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completedOperations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "overallProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastUpdatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "KeyValuePairOfInt64AndProductProgressDto",
            "kind": "LinkedField",
            "name": "productProgress",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductProgressDto",
                "kind": "LinkedField",
                "name": "value",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/),
                  (v5/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductTaskResultDto",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "overallStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "overallErrorType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "overallErrorMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalProducts",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "successfulProducts",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "failedProducts",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "KeyValuePairOfInt64AndCloneProductResultDto",
            "kind": "LinkedField",
            "name": "productResults",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CloneProductResultDto",
                "kind": "LinkedField",
                "name": "value",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/),
                  (v5/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "productSKU",
                    "storageKey": null
                  },
                  (v2/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "errorType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "errorMessage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "newProductId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productDuplicationTaskQueriesTaskQuery",
    "selections": (v6/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productDuplicationTaskQueriesTaskQuery",
    "selections": (v6/*:: as any*/)
  },
  "params": {
    "cacheID": "32ddc1437c3a5314172a90c7ae18b598",
    "id": null,
    "metadata": {},
    "name": "productDuplicationTaskQueriesTaskQuery",
    "operationKind": "query",
    "text": "query productDuplicationTaskQueriesTaskQuery(\n  $taskId: Long!\n) {\n  productTask(taskId: $taskId) {\n    id\n    taskID\n    type\n    status\n    taskState\n    isLocked\n    createdOn\n    modifiedOn\n    settings {\n      sourceProductId\n      destinationProductIds\n      destinationProducts {\n        id\n        sku\n        name\n        imageUrl\n        statusId\n      }\n      cloneTemplates\n      assignPricingRules\n      salesChannelId\n      sellerID\n      userID\n    }\n    progress {\n      currentProductId\n      totalOperations\n      completedOperations\n      overallProgress\n      startedAt\n      lastUpdatedAt\n      productProgress {\n        key\n        value {\n          productId\n          productName\n          status\n        }\n      }\n    }\n    result {\n      overallStatus\n      overallErrorType\n      overallErrorMessage\n      completedAt\n      totalProducts\n      successfulProducts\n      failedProducts\n      productResults {\n        key\n        value {\n          productId\n          productName\n          productSKU\n          status\n          errorType\n          errorMessage\n          newProductId\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6c87bff4e39cdd234efaaba9befcade4";

export default node;
